export const CLIENT_TYPES = {
 CLIENT_SELECTED_TREATMENT_PLAN_ID:"CLIENT_SELECTED_TREATMENT_PLAN_ID",
 CLIENT_GET_CAP_SERVICES:"CLIENT_GET_CAP_SERVICES",
 CLIENT_SAVE_CAP_SERVICES:"CLIENT_SAVE_CAP_SERVICES",
 CLIENT_TP_SELECTED_TAB_INACTIVE_ACTIVE:"CLIENT_TP_SELECTED_TAB_INACTIVE_ACTIVE",
 CLIENT_GET_GENDER_LIST: "CLIENT_GET_GENDER_LIST",
 CLIENT_SAVE_GENDER_LIST: "CLIENT_SAVE_GENDER_LIST",
 CLIENT_GET_STATE_LIST: "CLIENT_GET_STATE_LIST",
 CLIENT_SAVE_STATE_LIST: "CLIENT_SAVE_STATE_LIST",
 GET_AUTH_SERVICE_REVIEWS_REQUEST: "GET_AUTH_SERVICE_REVIEWS_REQUEST",
 SAVE_AUTH_SERVICE_REVIEWS_REQUEST: "SAVE_AUTH_SERVICE_REVIEWS_REQUEST"
}